import { getApiInstance } from '../helpers';

const getInboxes = (): Promise<any[]> => {
  return getApiInstance()
    .get('/inbox/list')
    .then((res) => {
      console.info('/inbox/list', res);
      // let mocked = [];
      // let i = 0;
      // while (i <= 20) {
      //   mocked = mocked.concat(res.data);
      //   i++;
      // }
      // return mocked;
      return res.data;
    });
};

export const inboxesService = {
  getInboxes,
};
